export default {
    UserId: '',
    User: {},
    Users: [],
    TotalInfo: {
        count: 0,
        limit: 20,
        page: 1,
        rows: []
    },
    UserPage: {},
    UserLogin: {}
}